export const modalId = 'CollectRecurrenceTargetRangeModal'
